import { gql } from '@apollo/client'

export const GQL_QUERY_GET_ADDRESS_SUGGESTIONS = gql`
  query($address: String!) {
    getAddressSuggestions(address: $address) {
      suggestions {
        value
        unrestricted_value
        data {
          house
          house_type
          region
          area
          area_type
          city
          city_with_type
          city_district
          street_with_type
          settlement
          settlement_type
          geo_lat
          geo_lon
        }
      }
    }
  }
`
